var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#2A2441",
    x: 27,
    y: 0,
    width: 5,
    height: 23.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#2A2441",
    transform: "translate(6.717514, 25.081475) rotate(-45.000000) translate(-6.717514, -25.081475) ",
    x: 4.21751442,
    y: 18.0814755,
    width: 5,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#2A2441",
    transform: "translate(6.717514, 18.717514) rotate(-315.000000) translate(-6.717514, -18.717514) ",
    x: 4.21751442,
    y: 11.7175144,
    width: 5,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#2A2441",
    transform: "translate(19.000000, 22.000000) rotate(-270.000000) translate(-19.000000, -22.000000) ",
    x: 16.5,
    y: 9,
    width: 5,
    height: 26
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.3c1baab370ff52a435e89e61d413b35e.svg";
export { ForwardRef as ReactComponent };